import React from "react";
import { t } from "../../../../utils/i18n";

const SubmitButton = ({ creating, integration, errors }) => {
  return (
    <>
      {/* Submit Error Message */}
      {errors.submit && (
        <div className="error-message submit-error" role="alert">
          {errors.submit}
        </div>
      )}

      {/* Submit Button */}
      <button
        type="submit"
        className="generate-link-btn"
        style={{ backgroundColor: "#4c3f84", color: "#fff", border: "none" }}
        disabled={creating}
      >
        {creating ? (
          <>
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>{" "}
            {t("store_integrations.widget.generating")}
          </>
        ) : integration && integration.id ? (
          t("store_integrations.widget.update_link")
        ) : (
          t("store_integrations.widget.generate_link")
        )}
      </button>
    </>
  );
};

export default SubmitButton;
